import { FC } from 'react';
import QrCode, { ImageSettings } from 'qrcode.react';

interface QRCodeProps {
  value: string;
  size?: number;
  imageSettings?: ImageSettings;
}

export const QRCode: FC<QRCodeProps> = ({
  value,
  size,
  imageSettings = {}
}) => (
  <QrCode
    value={value}
    size={size}
    imageSettings={imageSettings as ImageSettings}
    renderAs="svg"
  />
);
